import { render, staticRenderFns } from "./BulkServicesModal.vue?vue&type=template&id=36b5781c&scoped=true&"
import script from "./BulkServicesModal.vue?vue&type=script&lang=js&"
export * from "./BulkServicesModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkServicesModal.vue?vue&type=style&index=0&id=36b5781c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5781c",
  null
  
)

export default component.exports